import { InterviewLanguage } from "../constants/languages.js";
import {
  getCustomFieldDefinitionImportanceOrder
} from "./customField.js";
const SpecialAssessmentFieldName = {
  CefrLanguageLevelEnglish: "cefr_language_level_english",
  CefrLanguageLevelGerman: "cefr_language_level_german"
};
const allSpecialAssessmentFieldNames = [
  SpecialAssessmentFieldName.CefrLanguageLevelEnglish,
  SpecialAssessmentFieldName.CefrLanguageLevelGerman
];
const cefrLanguageAssessmentFieldNames = [
  SpecialAssessmentFieldName.CefrLanguageLevelEnglish,
  SpecialAssessmentFieldName.CefrLanguageLevelGerman
];
function checkIsCefrLanguageAssessmentFieldName(fieldName) {
  return cefrLanguageAssessmentFieldNames.some(
    (languageFieldName) => languageFieldName === fieldName
  );
}
const CefrAssessmentFieldNameToLanguage = {
  [SpecialAssessmentFieldName.CefrLanguageLevelEnglish]: InterviewLanguage.ENGLISH,
  [SpecialAssessmentFieldName.CefrLanguageLevelGerman]: InterviewLanguage.GERMAN
};
const LanguageToCefrAssessmentFieldName = {
  [InterviewLanguage.ENGLISH]: SpecialAssessmentFieldName.CefrLanguageLevelEnglish,
  [InterviewLanguage.GERMAN]: SpecialAssessmentFieldName.CefrLanguageLevelGerman
};
function isCefrLanguageAssessmentLanguage(language) {
  return language in LanguageToCefrAssessmentFieldName;
}
const CANDIDATE_ALIGN_FIELD_NAME = "Candidate's preferences and working style are aligned with the job";
const isSpecialAssessmentFieldName = (fieldName) => {
  return allSpecialAssessmentFieldNames.includes(
    fieldName
  );
};
const getSpecialAssessmentField = (customFieldDefinitions, specialFieldName) => {
  return customFieldDefinitions.find(
    (d) => d.field_name === specialFieldName
  );
};
function findCEFRLanguageAssessmentField(customFieldDefinitions) {
  return customFieldDefinitions.find(
    (d) => checkIsCefrLanguageAssessmentFieldName(d.field_name)
  );
}
function mapAssessmentDBToAssessment(assessmentDB, customFieldDefinitions) {
  return {
    id: assessmentDB.id,
    custom_field_definitions: customFieldDefinitions
  };
}
function sortAssessmentFields(fields) {
  return fields.toSorted((a, b) => {
    const aSpecial = isSpecialAssessmentFieldName(a.field_name);
    const bSpecial = isSpecialAssessmentFieldName(b.field_name);
    if (aSpecial && !bSpecial) {
      return -1;
    }
    if (!aSpecial && bSpecial) {
      return 1;
    }
    const aImportanceOrder = getCustomFieldDefinitionImportanceOrder(
      a.settings?.importance
    );
    const bImportanceOrder = getCustomFieldDefinitionImportanceOrder(
      b.settings?.importance
    );
    if (aImportanceOrder !== bImportanceOrder) {
      return aImportanceOrder - bImportanceOrder;
    }
    return a.field_name.localeCompare(b.field_name, void 0, {
      sensitivity: "base"
    });
  });
}
const ASSESSMENT_FIELD_NAME_MIN_LENGTH = 10;
const ASSESSMENT_FIELD_NAME_MAX_LENGTH = 500;
function getErrorMessageForAssessmentCriteriaValue(value) {
  if (value.length < ASSESSMENT_FIELD_NAME_MIN_LENGTH) {
    return `Criteria must be at least ${ASSESSMENT_FIELD_NAME_MIN_LENGTH} characters long`;
  }
  if (value.length > ASSESSMENT_FIELD_NAME_MAX_LENGTH) {
    return `Criteria must not exceed ${ASSESSMENT_FIELD_NAME_MAX_LENGTH} characters`;
  }
  if (isSpecialAssessmentFieldName(value)) {
    return "This field name is reserved, please choose another one";
  }
  return "";
}
function getAssessmentFieldChanges(originalFields, newFields) {
  const removedFields = originalFields.filter(
    (field) => !newFields.map((f) => f.id).includes(field.id)
  );
  const fieldsToAdd = newFields.filter((field) => !field.id);
  return {
    fieldsToRemove: removedFields,
    fieldsToAdd,
    hasChanges: removedFields.length > 0 || fieldsToAdd.length > 0
  };
}
function getHaveAssessmentFieldsChanged(originalFields, newFields) {
  return getAssessmentFieldChanges(originalFields, newFields).hasChanges;
}
export {
  ASSESSMENT_FIELD_NAME_MAX_LENGTH,
  ASSESSMENT_FIELD_NAME_MIN_LENGTH,
  CANDIDATE_ALIGN_FIELD_NAME,
  CefrAssessmentFieldNameToLanguage,
  LanguageToCefrAssessmentFieldName,
  SpecialAssessmentFieldName,
  allSpecialAssessmentFieldNames,
  checkIsCefrLanguageAssessmentFieldName,
  findCEFRLanguageAssessmentField,
  getAssessmentFieldChanges,
  getErrorMessageForAssessmentCriteriaValue,
  getHaveAssessmentFieldsChanged,
  getSpecialAssessmentField,
  isCefrLanguageAssessmentLanguage,
  isSpecialAssessmentFieldName,
  mapAssessmentDBToAssessment,
  sortAssessmentFields
};
//# sourceMappingURL=assessment.js.map
